import Rx from 'rx';

// see https://github.com/Reactive-Extensions/RxJS/blob/master/doc/howdoi/eventemitter.md
export default class EventsEmitter {
  constructor() {
    this.subjects = {};
  }

  emit(name, data) {
    let fnName = `\$${name}`;
    this.subjects[fnName] || (this.subjects[fnName] = new Rx.Subject());
    this.subjects[fnName].onNext(data);
    return this;
  }

  on(name, handler) {
    let fnName = `\$${name}`;
    this.subjects[fnName] || (this.subjects[fnName] = new Rx.Subject());
    this.subjects[fnName].subscribe(handler);
    return this;
  }

  dispose() {
    let subjects = this.subjects;
    for (let prop in subjects) {
      if (hasOwnProperty.call(subjects, prop)) {
        subjects[prop].dispose();
      }
    }
    this.subjects = {};
    return this;
  }
}


/** WEBPACK FOOTER **
 ** ./src/services/eventEmitter.js
 **/